import { Component } from '@angular/core';
import { LoadingController, NavController, Platform, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

import { LoginModel, UserProvider } from '../../../providers/user/user';
import { LoaderProvider } from '../../../providers/loader/loader';
import { BackgroundGeolocation } from '@awesome-cordova-plugins/background-geolocation/ngx';
import { SessionProvider } from '../../../providers/session/session';
import { ConfigProvider } from '../../../providers/config/config';
import { AdsProvider } from '../../../providers/ads/ads';
import { AppDetectorProvider } from '../../../providers/detector/detector';
import { Subscription } from 'rxjs';
import { DarkMode, ThemeMode } from '../../../providers/dark-mode/dark-mode';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { NavigationService } from 'src/providers/navigation/navigation.service';
import { environment } from 'src/environments/environment';
declare var cordova: any;
/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
  styleUrls:['./login.scss']
})
export class LoginPage{
  resolve: any;
  success: boolean = false;
  isIOS: boolean = false;
  isRootNav: boolean = true;
  isPremium:boolean=false;

  // darkMode
  toDark:boolean;
  toDarkSub:Subscription;
  previousUrl:string;

  constructor(
    public router:Router,
    public translate: TranslateService,
    public navCtrl: NavController,
    public userService: UserProvider,
    public loadingCtrl: LoadingController,
    // private iab: InAppBrowser,
    private toastCtrl: ToastController,
    private sessionService: SessionProvider,
    private platform: Platform,
    private ads:AdsProvider,
    private appDetector: AppDetectorProvider,
    private darkModeService:DarkMode,
    private location:Location,
    private navService:NavigationService,
  ) {
    this.platform.ready().then(async () => {
      this.isIOS = this.platform.is('ios');
      const nav = this.router.getCurrentNavigation();
      const state = nav?.extras?.state || null;
      console.log('state', state)
      if (state && typeof state?.['isRootNav'] == "boolean") {
        this.isRootNav = state?.['isRootNav'];
      }
      // if (state&&state?.['resolve']){
      //    this.resolve = state?.['resolve'];
      // }
      this.sessionService.getLogin().then(mod => {
        this.loginModel = mod;
      });
      this.previousUrl = this.navService.getPreviousUrl();
    });
  }

  loginModel: LoginModel = { email: '', password: '' };
  rememberMe: boolean = true;
  ionViewDidEnter() {
    console.log('ionViewDidEnter LoginPage');
    this.toDarkSub = this.darkModeService.themeModeSubject.subscribe((mode: ThemeMode) => {
      this.toDark = (mode === ThemeMode.DarkMode);
      let body = <HTMLElement>document.querySelector('body');

      if (this.toDark) {
        body.classList.add(ThemeMode.DarkMode);
      } else if (body && !this.toDark && body.classList.contains(ThemeMode.DarkMode)) {
        body.classList.remove(ThemeMode.DarkMode);
      }
    });
  }

  async login() {
    if (!navigator.onLine) {
      this.showLoader('NO_INTERNET_CONNECTION', 3000);
      return;
    }

    let loader = await this.loadingCtrl.create({ message: this.translate.instant('GLOBAL_LOADING') });
    this.userService.login(this.loginModel).then(success => {
      loader.dismiss();

      if (success) {
        // if (this.resolve) this.resolve(true);
        this.onLogin();
        this.saveLoginLocal();
        localStorage.setItem('premium', JSON.stringify(this.sessionService.profile.premium));
      } else {
        this.showToast("LOGIN_ERROR_NOT_VALID_CREDENTIALS", 4000);
      }


    }).catch((err) => {
      console.log("Login error: " + err);
    })
  }

  saveLoginLocal() {
    this.sessionService.saveLogin((this.rememberMe) ? this.loginModel : { emal: '', password: '' }).catch(err => console.log(err));
  }

  showToast(message: string, duration: number) {
    this.toastCtrl
      .create({
        message: this.translate.instant(message),
        buttons:[{text:'OK', role:'cancel'}],
        duration: duration
      }).then(toast=>toast.present());
  }

  async showLoader(message: string, duration: number) {
    let loader = await this.loadingCtrl.create({
      message: this.translate.instant(message)
    });
    loader.present();

    setTimeout(() => {
      loader.dismiss();
    }, duration);
  }

  onLogin() {
    console.log('this.isRootNav', this.isRootNav)
    this.sessionService.isLoged = true;
    this.sessionService.sendLoggedIn();

    // this.checkForOrganizerLogin();
    if (this.isRootNav) {
      this.location.back();
      // if (this.app.getActiveNavs().length >= 1 || this.app.getRootNavs().length > 1) {
      // (this.app.getRootNav() as NavController).pop();
      // }
    } else {
      this.navCtrl.back();
    }
  }

  checkForOrganizerLogin() {
    if (this.sessionService.profile.status.toLocaleUpperCase().includes("VERANSTALTER")) {
      this.toastCtrl.create({
        message: this.translate.instant('ORGANIZER_LOGIN_MESSAGE'),
        duration: 5000
      }).then(toast=>toast.present());
      this.userService.logout();
    }
  }

  /**
   * Keycloak OAuth login via InAppBrowser (Cordova) or window.open (browser dev).
   *
   * Native flow (Cordova):
   *  1. InAppBrowser opens keycloak/authorization/{provider}?redirect_uri=CALLBACK
   *  2. Keycloak authenticates and redirects to CALLBACK?code=XXX
   *  3. loadstart intercepts the URL → close browser
   *  4. App fetches GET /oauth/callback?code=XXX&redirect_uri=CALLBACK → JWT
   *
   * Browser dev flow (ionic serve):
   *  Opens the auth URL in a new tab for manual inspection.
   *  Automatic token exchange is not possible in a plain browser context.
   */
  private async loginWithKeycloak(provider: 'google' | 'facebook' | 'apple'): Promise<string | null | 'DEEPLINK_PENDING'> {
    console.log(`[OAuth][1] loginWithKeycloak called, provider: ${provider}, platform cordova: ${this.platform.is('cordova')}`);

    const callbackUri = `${environment.loginApi}oauth/callback`;
    const authUrl = `${environment.loginApi}keycloak/authorization/${provider}?redirect_uri=${encodeURIComponent(callbackUri)}`;

    // ── BROWSER FLOW ──────────────────────────────────────────────────────────
    // Use browser flow when: not cordova at all, OR running via http/https (web deployment with Cordova plugins bundled)
    // const isNativeApp = this.platform.is('cordova') && !window.location.protocol.startsWith('http');
    const isNativeApp =(this.platform.is('ios')|| this.platform.is('android'))&& !this.platform.is('pwa')&&!window.location.protocol.startsWith('http');
    console.log("isNativeApp", isNativeApp)
    if (!isNativeApp) {
      console.log('[OAuth][2] Browser mode detected (protocol:', window.location.protocol, ', cordova:', this.platform.is('cordova'), ')');
      return new Promise<string | null>(async (resolve) => {
        try {
          const browserRedirectUri = window.location.origin + '/auth/callback';
          const backendUrl = `${environment.loginApi}keycloak/authorization/${provider}`
            + `?redirect_uri=${encodeURIComponent(browserRedirectUri)}`;

          console.log('[OAuth][3] Fetching Keycloak URL from backend:', backendUrl);
          const res = await fetch(backendUrl);
          const keycloakUrl = (await res.text()).trim();
          console.log('[OAuth][4] Received Keycloak URL:', keycloakUrl);

          if (!keycloakUrl.startsWith('http') && !keycloakUrl.startsWith('https')) {
            console.error('[OAuth][4] ERROR — response is not a valid URL');
            resolve(null); return;
          }

          console.log('[OAuth][5] Opening Keycloak login in popup');
          window.location.assign(keycloakUrl);
        } catch (e) {
          console.error('[OAuth][ERROR] Browser flow failed:', e);
          resolve(null);
        }
      });
    }

    // ── NATIVE FLOW (system browser + deep link callback) ────────────────────
    // InAppBrowser (WebView) is blocked by Google OAuth ("disallowed_useragent").
    // Instead: open in the real system browser (Chrome/Safari), receive callback
    // via the custom URL scheme  spooorts://oauth/callback?code=XXX
    // which is handled by ionic-plugin-deeplinks → app.component.ts → OAuthCallbackPage.
    console.log('[OAuth][2] Native mode detected (protocol:', window.location.protocol, ')');

    const nativeRedirectUri = 'spooorts://oauth/callback';
    const nativeBackendUrl = `${environment.loginApi}keycloak/authorization/${provider}`
      + `?redirect_uri=${encodeURIComponent(nativeRedirectUri)}`;

    let keycloakUrl: string;
    try {
      console.log('[OAuth][3] Fetching Keycloak URL from backend:', nativeBackendUrl);
      const res = await fetch(nativeBackendUrl);
      keycloakUrl = (await res.text()).trim();
      console.log('[OAuth][4] Received Keycloak URL:', keycloakUrl);
      if (!keycloakUrl.startsWith('http')) {
        console.error('[OAuth][4] ERROR — response is not a valid URL');
        return null;
      }
    } catch (e) {
      console.error('[OAuth][ERROR] Failed to fetch Keycloak URL:', e);
      return null;
    }

    console.log('[OAuth][5] Opening Keycloak URL in system browser (Chrome/Safari):', keycloakUrl);
    // _system opens the real Chrome/Safari, not a WebView — Google allows this
    if((this.platform.is('ios')|| this.platform.is('android'))&& !this.platform.is('pwa')){
      console.log('keycloakUrl', keycloakUrl)
      cordova.InAppBrowser.open(keycloakUrl,'_system')
    }else if((this.platform.is('ios')|| this.platform.is('android'))&& this.platform.is('pwa')) {
      console.log('keycloakUrl', keycloakUrl)
      cordova.InAppBrowser.open(keycloakUrl,'_blank')
    }else{
      window.open(keycloakUrl, '_system');
    }

    // Login will complete via deep link: spooorts://oauth/callback?code=XXX
    // app.component.ts deeplink handler will navigate to /auth/callback
    // OAuthCallbackPage will exchange the code for a token and navigate home.
    console.log('[OAuth][6] Waiting for deep link callback spooorts://oauth/callback…');
    return 'DEEPLINK_PENDING';
  }

  private async handleKeycloakLogin(provider: 'google' | 'facebook' | 'apple') {
    const loader = await this.loadingCtrl.create({ message: this.translate.instant('GLOBAL_LOADING') });
    await loader.present();

    let handled = false;
    try {
      const result = await this.loginWithKeycloak(provider);

      if (result === 'DEEPLINK_PENDING') {
        // Native flow: system browser opened, login will complete via deep link.
        // OAuthCallbackPage handles token exchange and navigation — dismiss loader here.
        console.log('[OAuth] Native deep link flow started — dismissing loader, awaiting deep link callback');
        handled = true;
        await loader.dismiss();
        return;
      }

      const token = result as string | null;
      console.log(`[OAuth][8] loginWithKeycloak resolved, token present: ${!!token}`);

      if (token) {
        console.log('[OAuth][9] Calling userService.setToken…');
        await this.userService.setToken(token);
        console.log('[OAuth][10] Token saved, dismissing loader and calling onLogin()');
        await loader.dismiss();
        handled = true;
        this.onLogin();
      } else {
        console.warn('[OAuth][8] No token received — login cancelled or failed');
      }
    } catch (e) {
      console.error('[OAuth][ERROR] handleKeycloakLogin failed:', e);
    } finally {
      if (!handled) {
        await loader.dismiss().catch(() => {});
      }
    }
  }

  async onGoogleLogin() {
    await this.handleKeycloakLogin('google');
  }

  async onFacebookLogin() {
    await this.handleKeycloakLogin('facebook');
  }

  async onAppleLogin() {
    await this.handleKeycloakLogin('apple');
  }

  // openForgotPass() {
  //   let browser = this.iab.create('https://spooorts.de/login/forgot-password', "_blank", { hardwareback: 'yes' });
  //   browser.show();
  // }
  openForgotPass() {
    if (this.platform.is('cordova')) {
      const browser = cordova.InAppBrowser.open('https://spooorts.de/login/forgot-password','_blank','hardwareback=yes');

      browser.addEventListener('loadstop', () => {
        browser.show(); 
      });

      browser.addEventListener('exit', () => {
        console.log('InAppBrowser closed');
      });
    } else {
      window.open('https://spooorts.de/login/forgot-password', '_blank');
    }
  }

  openReg() {
    // if (this.resolve) {
    //   (this.app.getRootNav() as NavController).pop();
    //   this.app.getRootNav().push(RegistrationPage, { resolve: this.resolve });
    // } else {
    //   (this.app.getRootNav() as NavController).pop();
    //   this.app.getRootNav().push(RegistrationPage);
    // }
    // if (this.resolve) {
    //   this.router.navigate(['/registration'], { state: { resolve: this.resolve } });
    // } else {
    //   this.router.navigate(['/registration']);
    // }
    this.navCtrl.navigateForward('/auth/registration');
  }

  openLog() {
    // this.app.getRootNav().push(MysportUserProfilePage);
    // this.navCtrl.navigateForward('/me/mysport/user-profile');
  }

  ionViewWillLeave() {

  }
}
